export default {
    slug: 'categories',
    title: 'Categories',
    visible: [
        'name',
    ],
    listview: 'CategoryListView',
    locales: ['common'],
    columns: [
        {
            key: 'name',
            label: 'Name',
            main: true,
        }
    ],
}


// WEBPACK FOOTER //
// ./src/app/store/categories/state.js